export const purchasing = {
  description: "Suppliers, purchase orders, and goods receipts.",
  contact: "Contact",
  order: "Order",
  supplier: "Supplier",
  job: "Job",
  addSupplier: "Add supplier",
  newPurchaseOrder: "New purchase order",
  suppliers: "Suppliers",
  purchaseOrders: "Purchase orders",
  emptyTitle: "No purchase orders",
  emptyDescription: "Create an order to buy stock or outsource a process.",
  selectOrder:
    "Select a purchase order to see lines, outstanding quantities, and receipts.",
  createOrder: "Create order",
  forJob: "For job (optional)",
  noneStockOrder: "None (stock order)",
  lines: "Lines",
  addLine: "Add line",
  unitCost: "Unit cost",
  createdToast: "Purchase order created",
  forJobText: "For job {number}",
  expected: "expected {date}",
  receivedCount: "{received}/{ordered} received",
  outstandingCount: "{outstanding} outstanding",
  receipts: "Receipts",
  ref: "ref {reference}",
  receive: "Receive",
  cancelledToast: "Purchase order cancelled",
  location: "Location",
  supplierReference: "Supplier reference",
  supplierReferenceHint: "Delivery note or invoice number.",
  receiving: "Receiving…",
  recordReceipt: "Record receipt",
  receiptRecorded: "Receipt recorded",
  outstandingNote: "(outstanding {outstanding})",
  addSupplierTitle: "Add a supplier",
  saveSupplier: "Save supplier",
  paymentNote: "Payment note",
  addedToast: "Supplier added",
};
